import { FileType } from '@fi-shared/types';

export const ImageMovieFileTypes: FileType[] = [FileType.Movie, FileType.Image];
